import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TitledPageComponent } from 'src/app/shared/components/titled-page/titled-page.component';

@Component({
  selector: 'app-groups',
  standalone: true,
  imports: [CommonModule, RouterOutlet, TitledPageComponent],
  templateUrl: './groups.component.html',
  styleUrl: './groups.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupsComponent {}
